import { useEffect, useState } from "react";

export default function Navbar() {
  const [active, setActive] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll("section");

    const onScroll = () => {
      let current = "";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.pageYOffset >= sectionTop - 200) {
          current = section.getAttribute("id");
        }
      });

      setActive(current);
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkClass = (id) =>
    `cursor-pointer transition ${
      active === id
        ? "text-green-600 font-semibold"
        : "hover:text-green-600"
    }`;

  return (
    <header
      className={`fixed w-full top-0 z-50 transition ${
        scrolled
          ? "bg-white/80 backdrop-blur shadow"
          : "bg-white"
      }`}
    >
      <div className="flex justify-between items-center p-5 max-w-7xl mx-auto">

        <img src="/images/logo.png" alt=""></img>

        {/* DESKTOP MENU */}
        <nav className="hidden md:flex items-center gap-8">
          <a href="#hero" className={linkClass("hero")}>Home</a>
          <a href="#products" className={linkClass("products")}>Products</a>
          <a href="#about" className={linkClass("about")}>About</a>
          <a href="#contact" className={linkClass("contact")}>Contact</a>

          {/* CTA BUTTON */}
          <a
            href="#contact"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition"
          >
            Enquire
          </a>
        </nav>

        {/* MOBILE BUTTON */}
        <button
          className="md:hidden text-2xl"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow px-6 pb-4 space-y-4">
          <a href="#hero" onClick={() => setMenuOpen(false)} className={linkClass("hero")}>Home</a>
          <a href="#products" onClick={() => setMenuOpen(false)} className={linkClass("products")}>Products</a>
          <a href="#about" onClick={() => setMenuOpen(false)} className={linkClass("about")}>About</a>
          <a href="#contact" onClick={() => setMenuOpen(false)} className={linkClass("contact")}>Contact</a>

          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="block text-center bg-green-600 text-white py-2 rounded"
          >
            Enquire
          </a>
        </div>
      )}
    </header>
  );
}